import { observable } from "mobx";

export class MasterEventModel {
    id: string;
    branchId: string;
    gameTime: number;
    @observable gameStatus: number;
    constructor(source: MasterEventModel) {
        this.id = source.id;
        this.branchId = source.branchId;
        this.gameTime = source.gameTime;
        this.gameStatus = source.gameStatus;
    }
}